/* src/app/checkup/presenters/checkup-presenter.component.scss */
/*# sourceMappingURL=checkup-presenter.component.css.map */
